import { Scene, SuperContainer } from "onearm";
import { gsap } from "gsap";
import { Signal } from "typed-signals";
import { ReelsFrameController } from "../../controllers/ReelsFrameController.js";

export class GameIntroScene extends Scene {
    create(params) {
        super.create(params);

        this.layout = this.buildLayout("GameInfoLayout");
        this.reelsContainer = new SuperContainer();
        this.layout.findInCurrentLayout("ReelsPlaceholder").addChild(this.reelsContainer);

        this.reelsFrame = new ReelsFrameController(this.layout.findAll("ReelsFrame"));
        this.reelsFrame.showFrame("FreeGame");

        this.onPressPlay = new Signal();
        this.onChangeDontShowAgain = new Signal();

        this.forAll("game_info_texts", (gameInfoTexts) => {
            this.getToggleTimeline(gameInfoTexts.children);
        });

        this.forAll("PlayButton", (playButton) => {
            playButton.onPress.connect(() => this.onPressPlay.emit());

            gsap.to(playButton.btn.scale, {x: 1.15, y: 1.15, yoyo: true, repeat: -1, duration: 0.3});

        });

        this.forAll("CheckBox", (checkBox) => {
            checkBox.onChange.connect((value) => this.onChangeDontShowAgain.emit(value));
        });

        this.layout.onLayoutChange.connect(this.handleLayoutChange.bind(this));
        this.onChangeDontShowAgain.connect(this.handleChangeDontShowAgain.bind(this));
    }

    handleChangeDontShowAgain(value) {
        this.layout.forAll("CheckBox", (checkBox) => {
            checkBox.setState(value);
        });
    }

    handleLayoutChange() {
        this.layout.findInCurrentLayout("ReelsPlaceholder").addChild(this.reelsContainer);
    }

    getReelsContainer() {
        return this.reelsContainer;
    }

    getToggleTimeline(displayObjects) {
        const tl = gsap.timeline({
            repeat: -1,
        });

        displayObjects.forEach((child, i) => {
            child.alpha = 0;

            tl.to(child, {alpha: 1, duration: 0.5}, i * 2.5)
              .to(child, {alpha: 0, duration: 0.5}, i * 2.5 + 2);
        });

        return tl;
    }

    destroy() {
        // this.introPlayer.destroy();
    }
}
